'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TfIdfSearchIndex = require('./TfIdfSearchIndex');

Object.defineProperty(exports, 'TfIdfSearchIndex', {
  enumerable: true,
  get: function get() {
    return _TfIdfSearchIndex.TfIdfSearchIndex;
  }
});

var _UnorderedSearchIndex = require('./UnorderedSearchIndex');

Object.defineProperty(exports, 'UnorderedSearchIndex', {
  enumerable: true,
  get: function get() {
    return _UnorderedSearchIndex.UnorderedSearchIndex;
  }
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/js-search/dist/commonjs/SearchIndex/index.js
// module id = 381
// module chunks = 1